// Author thq
// Date 2021-12-07 09:49:48

class EmSicBoardModuleSdm {
constructor({
        id = null,
        code = '',
        name = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.remark = remark;
}
}

function newEntity() {
return new EmSicBoardModuleSdm();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.emSicBoardModuleSdm.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.statusCollection.emSicBoardModuleSdm.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.statusCollection.emSicBoardModuleSdm.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicBoardModuleSdm.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    codeFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.em.statusCollection.emSicBoardModuleSdm.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.statusCollection.emSicBoardModuleSdm.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.em.statusCollection.emSicBoardModuleSdm.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.statusCollection.emSicBoardModuleSdm.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicBoardModuleSdm.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSicBoardModuleSdm, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
